import { render, staticRenderFns } from "./ResearchAndReport.vue?vue&type=template&id=bbe183b0&scoped=true"
import script from "./ResearchAndReport.vue?vue&type=script&lang=js"
export * from "./ResearchAndReport.vue?vue&type=script&lang=js"
import style0 from "./ResearchAndReport.vue?vue&type=style&index=0&id=bbe183b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe183b0",
  null
  
)

export default component.exports